<div class="pfs-dashboard">
  <!-- Summary at the top -->
  <app-pfs-summary></app-pfs-summary>

  <!-- Client Charts below -->
  <app-pfs-client-charts></app-pfs-client-charts>
</div>
